import { render, staticRenderFns } from "./2023_newyear.vue?vue&type=template&id=6735a666&scoped=true&"
import script from "./2023_newyear.vue?vue&type=script&lang=js&"
export * from "./2023_newyear.vue?vue&type=script&lang=js&"
import style0 from "./2023_newyear.vue?vue&type=style&index=0&id=6735a666&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6735a666",
  null
  
)

export default component.exports